class Recruit {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    // スロットリング関数
    function throttle(callback, delay) {
      let last;
      let timer;
      return function () {
        const now = Date.now();
        if (last && now < last + delay) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            last = now;
            callback();
          }, delay);
        } else {
          last = now;
          callback();
        }
      };
    }

    // スクロールイベントの処理
    function handleScroll() {
      const $mv = $('.js-mv');
      const $fixedBtn = $('.js-fixedBtn');
      const $bottom = $('.js-bottom');
      
      if ($mv.length === 0 || $fixedBtn.length === 0 || $bottom.length === 0) return;

      const mvBottom = $mv.offset().top + $mv.outerHeight();
      const viewportTop = $(window).scrollTop();
      const bottomTop = $bottom.offset().top;
      const viewportBottom = viewportTop + $(window).height();

      // .js-mv が完全に見えなくなり、.js-bottom が見えていないときに .is-active を追加
      if (mvBottom < viewportTop && bottomTop > viewportBottom) {
        $fixedBtn.addClass('is-active');
      } else {
        $fixedBtn.removeClass('is-active');
      }
    }

    // スロットリングを適用してイベントリスナーを追加
    $(window).on('scroll', throttle(handleScroll, 100));

  }
}
